import { IoAlertCircleOutline } from 'react-icons/io5';
import { MdBlock } from 'react-icons/md';
import { TimerIcon } from './timer/TimerIcon';

/**
 * Icons for use in page-level alerts, modals, etc. 
 */
export default {
  ALERT: <IoAlertCircleOutline />,
  BLOCKED: <MdBlock />,
  TIMER_ICON: <TimerIcon seconds={30} />
};